.bo{flex-shrink:0;}